import React from 'react';
import { SFButton, SFIcon } from 'sfui';
import styles from './NoProjects.module.scss';
import { useHistory } from 'react-router';

export const NoProjects = (): React.ReactElement<{}> => {
  const history = useHistory();
  return (
    <div className={styles.noProjects}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <SFIcon icon="Preferences-1" size={96} />
        </div>

        <h2 className={styles.title}>No projects yet</h2>

        <p className={styles.subTitle}>
          The latest projects will be displayed here.
        </p>

        <SFButton
          className={styles.createProjectBtn}
          onClick={() => history.push('/app/settings', { section: 'projects' })}
          variant="contained"
          color="primary"
        >
          Create a Project
        </SFButton>
      </div>
    </div>
  );
};
